import Toastr from "../../../../itrust_common/components/Toastr"

const DEFAULT_STATE = {
  graph_data: {},
  kpi_data: {},
  saving: false,
}

let changes = null
export const aiReceptionistReportReducer = (state = DEFAULT_STATE, action) => {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {

    case 'AI_RECEPTIONIST_DASHBOARD_LOAD_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = { saving: false }
      return { ...state, ...changes };

    case 'AI_RECEPTIONIST_DASHBOARD_LOAD_FULFILLED':
      changes = {
        ...response,
        saving: false
      };
      return { ...state, ...changes }

    default:
      return state
  }
}